export default __webpack_public_path__ + "static/media/Diabetesmanagement.8fdbee65.svg";